// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + "da747506e4bf5fa678da" + ".js";
};